// extracted by mini-css-extract-plugin
export default {"header":"Pricing_header__nc0y7","mainItems":"Pricing_mainItems__kMESj","allItems":"Pricing_allItems__3uPwT","Content":"Pricing_Content__42PmM"};